import { render, staticRenderFns } from "./_id.baseLayout.vue?vue&type=template&id=c8145a74&"
import script from "./_id.baseLayout.vue?vue&type=script&lang=js&"
export * from "./_id.baseLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports